import { render, staticRenderFns } from "./newProject.vue?vue&type=template&id=4525b3f4&"
import script from "./newProject.vue?vue&type=script&lang=js&"
export * from "./newProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports